export interface GetSeparateDictionaryRequest {
  id: number
}

export function GetSeparateDictionaryRequestToJSON(
  value: GetSeparateDictionaryRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined
  }
}
